import Config from 'config'
// import HttpProvider from '@/services/HttpProvider'
import Bus from '@/services/Bus'

const Newsletter = {
  subscribeCustomer (storeViewCode, email) {
    let query = Config.API.newsletter.subscribeCustomer
    return Bus.get(query, {
      params: {
        storeViewCode: storeViewCode,
        email: email
      }
    })
      .then(res => {
        return res
      })
      .catch(err => {
        let e = err
        return e
      })
  }
}
export default Newsletter
